import { useEffect, useState } from 'react';
import firebase from 'lib/firebase';

const readBrowserOnlineState = () => (
  typeof navigator === 'undefined' ? true : navigator.onLine !== false
);

/**
 * Lightweight connection state for presentation only. Do not probe Firestore
 * here: health reads can queue behind the SDK's offline backoff and must not
 * participate in page rendering.
 */
export const useConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(readBrowserOnlineState);
  const firebaseConfigured = Boolean(firebase?.isConfigured && firebase?.db);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return {
    isOnline,
    hasLocalData: false,
    isOfflineCapable: isOnline,
    firebaseConnected: firebaseConfigured && isOnline,
    firebaseConfigured,
    // Individual Firebase operations determine actual server synchronization.
    serverSynced: false,
  };
};
